import React from "react";

import FlightIcon from "@mui/icons-material/Flight";

function FleetIcon({ iconColor, iconSize = "small", ...other }) {
    return <FlightIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default FleetIcon;
